export default [
  {
    content: {
      title: '<span class="title__line">THE CONDO</span><br /><span class="title__line">T-SHIRTS</span>',
    },
  },
  {
    content: {
      image: '/static/images/look_book/diesel_wynwood_img1.jpg',
      eyelet: '100% Pure Cotton',
    },
  },
  {
    content: {
      subtitle: 'Highest end. Shockingly stylish. Classiest class. Excessively Exclusive. 143 one-of-a-kind T-shirts.',
      text: 'A unique collection solely composed of 143 accurately machine sewn T-shirts inspired by Miami’s artistic and cultural hive, Wynwood.<br />Made of the purest cotton and extremely easy to fold, each piece is for all intents and purposes the definitive garment.',
    },
  },
  {
    content: {
      title: '<span class="title__line">BUY A T-SHIRT</span><br /><span class="title__line">AND GET</span><br /><span class="title__line">AN APARTMENT</span><br/ ><span class="title__line">FOR FREE*.</span>',
      smalltext: 'exclusions apply*',
    },
  },
  {
    content: [
      {
        title: 'S.M.L.',
        text: 'Size:<br />Small, Medium, Large.<br /><br />Value:<br />Short, Medium, Long Term.',
      },
      {
        title: 'Be Dynamic, Be Brave.',
        text: 'Become an integral part of a selected group of individuals who are certain of what they want. And that’s exactly what they’ll take.',
      },
    ],
  },
  {
    content: {
      image: '/static/images/look_book/diesel_wynwood_img2.jpg',
      eyelet: '',
    },
  },
  {
    content: {
      title: 'MADE TO BE WORN.',
      text: 'Is there a better place to dress this unique piece of garment than the most inclusive and creative area in America? We don’t think so.<br /><br />But don’t worry. You’re all set.<br />This collection is so exclusive that customers will receive an apartment in Miami’s most fashionable, on-the-rise neighborhood as a freebie.',
    },
  },
  {
    content: {
      title: 'DIESEL WYNWOOD - PRE-SALE SEASON',
    },
  },
  {
    content: [
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img3.jpg',
          title: 'T-SHIRT A1-L4<br />STUDIO<br />S SIZE',
          price: '$ 399.000',
          smalltext: 'exclusions apply*',
        },
      },
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img4.jpg',
          title: 'T-SHIRT D6-L4<br />2 BDRM<br />M SIZE',
          price: '$ 949.000',
          smalltext: 'exclusions apply*',
        },
      },
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img5.jpg',
          title: 'T-SHIRT E4-L4<br />2 BDRM + DEN<br />L SIZE',
          price: '$ 1.399.000',
          smalltext: 'exclusions apply*',
        },
      },
    ],
  },
  {
    content: {
      image: '/static/images/look_book/diesel_wynwood_img6.jpg',
    },
  },
  {
    content: [
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img7.jpg',
          title: 'T-SHIRT F1-L6<br />3 BDRM<br />XL SIZE',
          price: '$ 1.599.000',
          smalltext: 'exclusions apply*',
        },
      },
      {
        content: {
          image: '/static/images/look_book/diesel_wynwood_img8.jpg',
          title: 'T-SHIRT F2-L8<br />PENTHOUSE<br />XXL SIZE',
          price: '$ 5.500.000',
          smalltext: 'exclusions apply*',
        },
      },
    ],
  },
  {
    content: {
      title: 'THE MOST EXPENSIVE T-SHIRTS IN THE WORLD',
    },
  },
  {
    content: {
      title: '<span class="title__line">SUCH</span><br /><span class="title__line">IRRATIONAL</span><br /><span class="title__line">QUALITY,</span><br /><span class="title__line">THE PRICE TAG</span><br /><span class="title__line">LOOKS SANE</span><br /><span class="title__line">IN COMPARISON.</span>',
    },
  },
  {
    content: {
      subtitle: 'Accept No Compromises.<br />Only the Very Best is the Answer.',
      text: 'Art as well as business, a new take on what Urban Lifestyle means. A success that mingles metropolitan scapes with natural overtones.<br />The essence of Diesel: a total luxury collection of comfort and cutting edge Fashion.',
    },
  },
  {
    content: {
      image: '/static/images/look_book/diesel_wynwood_img9.jpg',
    },
  },
  {
    content: {
      title: '<span class="title__line"><span class="title__letter">C</span><span class="title__letter">O</span><span class="title__letter">N</span><span class="title__letter">T</span><span class="title__letter">A</span><span class="title__letter">C</span><span class="title__letter">T</span></span>',
    },
  },
];
